'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { SectionHeaderAccent } from './section-header-accent.tsx'
import { SectionHeaderMain } from './section-header-main.tsx'
import { SectionHeaderSubtitle } from './section-header-subtitle.tsx'
import { SectionHeaderTitle } from './section-header-title.tsx'
import {
  SectionHeaderProvider,
  type UseSectionHeaderProps,
  useSectionHeader,
} from './use-section-header.ts'

export type SectionHeaderProps = PropsWithChildren<
  UseSectionHeaderProps & { className?: string }
>

export const SectionHeaderComponent = ({
  children,
  className,
  ...props
}: SectionHeaderProps) => {
  const context = useSectionHeader(props)

  return (
    <SectionHeaderProvider value={context}>
      <div className={cn('flex gap-4 items-center', className)}>{children}</div>
    </SectionHeaderProvider>
  )
}

export const SectionHeader = Object.assign(SectionHeaderComponent, {
  Accent: SectionHeaderAccent,
  Main: SectionHeaderMain,
  Subtitle: SectionHeaderSubtitle,
  Title: SectionHeaderTitle,
})
